
import { writable } from 'svelte/store';

export const name = writable('');

export const items = writable(0.0);

export const jwt = writableSession('jwt', '');

function persist(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
}

export function writableSession(key, initialValue) {
    const sessionValue = JSON.parse(sessionStorage.getItem(key));
    if (!sessionValue) persist(key, initialValue);

    const store = writable(sessionValue || initialValue);
    store.subscribe(value => persist(key, value));
    return store;
}

export function removeSession(key) {
    sessionStorage.removeItem(key);
    sessionStorage.clear();
}